const plantLayoutColumns = (customHeaders?: string[]) => {
  const moreColumns = [];
  if(customHeaders && customHeaders.length > 0 ){
    customHeaders.map((oneheader) => {
      const newColumn = {
        Header: oneheader.toUpperCase(),
        accessor: oneheader,
        editType: null,
        options: []
      }
      moreColumns.push(newColumn);
    })
  }
  return (
    [
      {
        Header: 'Display Sequence',
        accessor: 'displayseq',
        editType: 'Number',
        options: []
      },
      {
        Header: 'Area',
        accessor: 'areacode',
        editType: 'Combobox',
        options: []
      },
      {
        Header: 'Zone',
        accessor: 'zonecode',
        editType: 'Combobox',
        options: []
      },
      {
        Header: 'Equipment',
        accessor: 'equipmentcode',
        editType: 'Combobox',
        options: []
      },
      {
        Header: 'Position No.',
        accessor: 'positionnumber',
        editType: 'Number',
        options: []
      },
      {
        Header: 'Consumable',
        accessor: 'consumablecode',
        editType: null,
        options: []
      },
      {
        Header: 'Consumables',
        accessor: 'consumablecodeext2',
        editType: null,
        options: []
      },
      {
        Header: 'Quantity Installed',
        accessor: 'quantityinstalled',
        editType: 'Number',
        options: []
      },
      {
        Header: 'Quantity Redressed',
        accessor: 'quantityredressed',
        editType: 'Number',
        options: []
      },
      {
        Header: 'Drawing No.',
        accessor: 'drawingnumber',
        editType: 'inputField',
        options: []
      },

      {
        Header: 'Active ?',
        accessor: 'isactive',
        editType: 'Boolean',
        options: []
      },
      {
        Header: 'Remarks',
        accessor: 'remarks',
        editType: 'inputField',
        options: []
      },
      ...moreColumns,

    ]
  )
}



export default plantLayoutColumns;
